import { render, staticRenderFns } from "./Frazionamento.vue?vue&type=template&id=0764ac80&"
import script from "./Frazionamento.vue?vue&type=script&lang=js&"
export * from "./Frazionamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports